import colors from '@settings/styleSettings'
import Modal from 'styled-react-modal'

import styled from 'styled-components'

export const Container = Modal.styled`
  font-family: 'Circular-Std';
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: absolute;
  width: 375px;
  height: 100%;
  right: 0;
  top: 0;
  background-color: ${colors.background};

  -webkit-animation-name: fadeInRight;
  animation-name: fadeInRight;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  @-webkit-keyframes fadeInRight {
    0% {
      opacity: 0;
      -webkit-transform: translate3d(100%, 0, 0);
      transform: translate3d(100%, 0, 0);
    }
    100% {
      opacity: 1;
      -webkit-transform: none;
      transform: none;
    }
  }
  @keyframes fadeInRight {
    0% {
      opacity: 0;
      -webkit-transform: translate3d(100%, 0, 0);
      transform: translate3d(100%, 0, 0);
    }
    100% {
      opacity: 1;
      -webkit-transform: none;
      transform: none;
    }
  }
  & > div {
    font-family: Circular-Std;
  }

  @media (max-width: 375px) {
    max-width: 100%;
    width: 100%;
  }
`

export const Section = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`

export const DetailsContainer = styled.div`
  color: ${colors.placeholder};
  border-top: 2px solid ${colors.grayBackground};
  margin: 1px 24px;
  padding-top: 32px;
`

export const DetailsCard = styled.div`
  height: fit-content;
  padding: 16px 12px;
  background-color: ${colors.grayBackground};
  border: 1px solid ${colors.softGray};
  border-radius: 12px;
`

export const Details = styled.div`
  color: ${colors.placeholder};
  margin-bottom: 24px;
`
